module.exports = __webpack_public_path__ + "static/media/CouponAppliedIcon.0e503b55.svg";